export const TECH_SPECS = [
  { t: "Panel height limit", d: "Wardrobe and tall-unit shutters are engineered to a maximum height of 2400mm. Beyond this, vertical aluminium joinery or tensioning stiffeners are mandatory to keep panels true." },
  { t: "Routed PU & Membrane bending", d: "Bending can occur in all plywood — especially when the design carries deep CNC routing in PU or Membrane finishes. Deep-routed designs are built on HDHMR cores with tension-rod backing, never plain plywood." },
  { t: "Wet-zone carcasses", d: "Sink modules and utility zones are built only in BWP ISO:710 grade marine plywood, sealed on all six sides against moisture ingress." },
  { t: "Hardware standard", d: "Blum / Hettich soft-close concealed hinges with 110° opening limiters, and undermount tandem channels rated for 30,000 cycles." }
];

const C = (n, h) => ({ n, h });
const D = (n, p, sample, sampleLabel, opts = {}) => ({ n, p, sample, sampleLabel, ...opts });

export const FINISHES = [
  {
    id: "pu", num: "01", title: "PU", accent: "sprayed polyurethane.",
    texture: "smooth",
    blurb: "Polyurethane in matt and glossy finishes, hand-sprayed in our Vasai paint booth. Nine photographed shutter designs, twenty house shades.",
    notes: [
      "Polyurethane — matt finish & glossy finish",
      "Deep routed PU profiles carry plywood bending risk — HDHMR substrate advised",
      "Shutter height capped at 2400mm without stiffeners"
    ],
    colours: [
      C("Porcelain", "#F5F2EA"), C("Ivory Mist", "#EFE9DD"), C("Bone", "#E3DAC8"), C("Sand", "#D9CFBE"),
      C("Silk Grey", "#C7C2B8"), C("Greige", "#B3A898"), C("Stone", "#A69C8E"), C("Taupe", "#8C7D6D"),
      C("Mocha", "#77614C"), C("Espresso", "#493E33"), C("Bronze", "#6B5844"), C("Charcoal", "#2A2723"),
      C("Ink Black", "#141210"), C("Sage", "#9AA08C"), C("Olive", "#6E6A4F"), C("Terracotta", "#B06B4C"),
      C("Clay", "#96604A"), C("Petrol", "#3E5451"), C("Midnight", "#232E3A"), C("Slate Blue", "#5A6672")
    ],
    designs: [
      D("Design 1", "slim", null, null, { photo: "/images/pu/photo-6.jpg", def: 0, watermark: { x: 26, y: 49, w: 50 } }),
      D("Design 2", "raised", null, null, { photo: "/images/pu/photo-7.jpg", def: 4 }),
      D("Design 3", "shaker", null, null, { photo: "/images/pu/photo-8.jpg", def: 2 }),
      D("Design 4", "raised", null, null, { photo: "/images/pu/photo-9.jpg", def: 11 }),
      D("Design 5", "raised", null, null, { photo: "/images/pu/photo-1.jpg", def: 5 }),
      D("Design 6", "arch", null, null, { photo: "/images/pu/photo-2.jpg", def: 4 }),
      D("Design 7", "shaker", null, null, { photo: "/images/pu/photo-3.jpg", def: 0 }),
      D("Design 8", "raised", null, null, { photo: "/images/pu/photo-4.jpg", def: 4 }),
      D("Design 9", "routed", null, null, { photo: "/images/pu/photo-5.jpg", def: 4 })
    ]
  },
  {
    id: "solidwood", num: "02", title: "Solidwood", accent: "timber, honoured.",
    texture: "grain",
    unit: "polishes",
    blurb: "Ash wood, framed and raised by joiners — ten signature shutter builds in six hand-rubbed polish tones. Real grain, never hidden.",
    notes: [
      "Ash wood, hand-finished in hardwax oil",
      "Solid timber moves with humidity — 2–3mm expansion gaps detailed",
      "Framed construction resists warping across seasons"
    ],
    colours: [
      C("Natural Clear", "#D9B98A"), C("Honey", "#BE8B4E"), C("Teak", "#9C6B3F"),
      C("Walnut", "#6B4A32"), C("Espresso", "#4A3626"), C("Charcoal", "#2E2A26")
    ],
    designs: [
      D("Design 1", "raised", null, null, { photo: "/images/solidwood/photo-3.jpg", def: 1 }),
      D("Design 2", "shaker", null, null, { photo: "/images/solidwood/photo-4.jpg", def: 4 }),
      D("Design 3", "rib", null, null, { photo: "/images/solidwood/photo-5.jpg", def: 3 }),
      D("Design 4", "raised", null, null, { photo: "/images/solidwood/photo-6.jpg", def: 3 }),
      D("Design 5", "glass", null, null, { photo: "/images/solidwood/photo-7.jpg", def: 1 }),
      D("Design 6", "raised", null, null, { photo: "/images/solidwood/photo-8.jpg", def: 0 }),
      D("Design 7", "rib", null, null, { photo: "/images/solidwood/photo-9.jpg", def: 0 }),
      D("Design 8", "raised", null, null, { photo: "/images/solidwood/photo-10.jpg", def: 3 }),
      D("Design 9", "slim", null, null, { photo: "/images/solidwood/photo-1.jpg", def: 0 }),
      D("Design 10", "raised", null, null, { photo: "/images/solidwood/photo-2.jpg", def: 0 })
    ]
  },
  {
    id: "membrane", num: "03", title: "Membrane", accent: "seamless pressed foil.",
    texture: "smooth",
    blurb: "German foil vacuum-pressed over CNC-routed HDHMR — seamless edges, soft-touch feel, and profiles that flow around every groove. Eight photographed shutter designs, twenty house shades.",
    notes: [
      "Seamless German foil pressed over CNC-routed HDHMR",
      "Deep routed designs risk bending on plywood cores — HDHMR only",
      "Shutter height capped at 2400mm"
    ],
    colours: [
      C("Cream", "#F0E9DC"), C("Vanilla", "#F3EADA"), C("Cashmere", "#E8DECB"), C("Mushroom", "#C5B9A6"),
      C("Stone Grey", "#ABA294"), C("Warm Grey", "#8F877B"), C("Cocoa", "#6E5B4A"), C("Coffee", "#54463A"),
      C("Graphite", "#3A3733"), C("Onyx", "#1E1C19"), C("Blush", "#D8C2B4"), C("Rosewood", "#9C6E5E"),
      C("Sage", "#A3A892"), C("Forest", "#4C5648"), C("Sky", "#B9C6CB"), C("Denim", "#55677A"),
      C("Oak", "#C8A97E"), C("Walnut", "#6B4F3A"), C("Cherry", "#7A4B38"), C("Wenge", "#3E2F26")
    ],
    designs: [
      D("Design 1", "arch", null, null, { photo: "/images/membrane/photo-1.jpg", def: 0 }),
      D("Design 2", "shaker", null, null, { photo: "/images/membrane/photo-2.jpg", def: 12 }),
      D("Design 3", "raised", null, null, { photo: "/images/membrane/photo-3.jpg", def: 2 }),
      D("Design 4", "raised", null, null, { photo: "/images/membrane/photo-4.jpg", def: 5 }),
      D("Design 5", "raised", null, null, { photo: "/images/membrane/photo-5.jpg", def: 16 }),
      D("Design 6", "raised", null, null, { photo: "/images/membrane/photo-6.jpg", def: 16 }),
      D("Design 7", "arch", null, null, { photo: "/images/membrane/photo-7.jpg", def: 14 }),
      D("Design 8", "raised", null, null, { photo: "/images/membrane/photo-8.jpg", def: 4 })
    ]
  },
  {
    id: "laminate", num: "04", title: "Laminate", accent: "Velora series · European laminates.",
    texture: "grain",
    noShades: true,
    blurb: "The Velora Series — premium European laminates pressed on BWP plywood: deep synchronised grain, soft-touch matte surface and an anti-scratch top coat, imported and laid with book-matched precision.",
    notes: [
      "Velora series European laminate, 1mm on BWP plywood",
      "Synchronised grain texture with anti-scratch top coat",
      "Tall unit shutters capped at 2400mm"
    ],
    colours: [
      C("White Ash", "#DDD6C8"), C("Natural Oak", "#C8A97E"), C("Ash Wood", "#B8A88F"), C("Grey Elm", "#9A948A"),
      C("Smoked Walnut", "#6B4F3A"), C("Wenge", "#3E2F26"), C("Teak", "#9C6B3F"), C("Maple", "#DCC39B"),
      C("Beech", "#C9A87C"), C("Pine", "#E6CFA5"), C("Cedar", "#A8763E"), C("Mahogany", "#6E3B2A"),
      C("Frost White", "#F2EFE9"), C("Ivory", "#EFE9DD"), C("Beige", "#D9CFBE"), C("Fawn", "#B9A88F"),
      C("Stone", "#A69C8E"), C("Graphite", "#33302C"), C("Charcoal", "#2A2723"), C("Ink", "#141210")
    ],
    designs: [
      D("Design 1", "slab", null, null, { photo: "/images/laminate/photo-1.jpg", def: 14 }),
      D("Design 2", "slab", null, null, { photo: "/images/laminate/photo-2.jpg", def: 4 }),
      D("Design 3", "slab", null, null, { photo: "/images/laminate/photo-3.jpg", def: 15 }),
      D("Design 4", "slab", null, null, { photo: "/images/laminate/photo-4.jpg", def: 3 }),
      D("Design 5", "slab", null, null, { photo: "/images/laminate/photo-5.jpg", def: 1 }),
      D("Design 6", "slab", null, null, { photo: "/images/laminate/photo-6.jpg" }),
      D("Design 7", "slab", null, null, { photo: "/images/laminate/photo-7.jpg" }),
      D("Design 8", "slab", null, null, { photo: "/images/laminate/photo-8.jpg" }),
      D("Design 9", "slab", null, null, { photo: "/images/laminate/photo-9.jpg" }),
      D("Design 10", "slab", null, null, { photo: "/images/laminate/photo-10.jpg" }),
      D("Design 11", "slab", null, null, { photo: "/images/laminate/photo-11.jpg" }),
      D("Design 12", "slab", null, null, { photo: "/images/laminate/photo-12.jpg" }),
      D("Design 13", "slab", null, null, { photo: "/images/laminate/photo-13.jpg" }),
      D("Design 14", "slab", null, null, { photo: "/images/laminate/photo-14.jpg" }),
      D("Design 15", "slab", null, null, { photo: "/images/laminate/photo-15.jpg" })
    ]
  },
  {
    id: "ceramic", num: "05", title: "Ceramic", accent: "stone, engineered.",
    texture: "stone",
    noShades: true,
    blurb: "Full-body 3mm ceramic slabs bonded to an aluminium profile core with T-Patti — featherlight, heat-proof to 300°C, UV-stable, and immune to stains and scratches. Five photographed designs with G-profile edge detailing.",
    notes: [
      "3mm full-body ceramic slab on aluminium profile core with T-Patti",
      "Heat-proof to 300°C — stain, scratch and UV resistant",
      "Featherlight panels; sliding on soft-close top-hung tracks"
    ],
    colours: [
      C("Sandstone", "#CBB899"), C("Travertine", "#D8C9AC"), C("Limestone", "#E0D8C4"), C("Statuario", "#EFECE6"),
      C("Marquina", "#1D1B18"), C("Basalt", "#3B3833"), C("Corten Bronze", "#7A5A44"), C("Corten Steel", "#6E5240"),
      C("Cement", "#9B968C"), C("Dark Cement", "#5F5B54"), C("Slate", "#4A4A48"), C("Pietra", "#8B877F"),
      C("Onyx Beige", "#D2C3A6"), C("Onyx Green", "#4E5B52"), C("Calacatta", "#F0EDE7"), C("Emperador", "#5E4B3A"),
      C("Terrazzo", "#C9C2B2"), C("Lava", "#2B2926"), C("Rust", "#8A5A3A"), C("Pearl", "#E6E2D8")
    ],
    designs: [
      D("Design 1", "jpull", null, null, { photo: "/images/ceramic/photo-1.jpg", def: 5 }),
      D("Design 2", "jpull", null, null, { photo: "/images/ceramic/photo-2.jpg", def: 3 }),
      D("Design 3", "jpull", null, null, { photo: "/images/ceramic/photo-3.jpg", def: 13 }),
      D("Design 4", "jpull", null, null, { photo: "/images/ceramic/photo-4.jpg", def: 15 }),
      D("Design 5", "jpull", null, null, { photo: "/images/ceramic/photo-5.jpg", def: 19 })
    ]
  },
  {
    id: "acrylic", num: "06", title: "Acrylic", accent: "back-painted gloss.",
    texture: "gloss",
    blurb: "Acrylic 2mm back painted on BWP with zero-edge laser banding — a single unbroken plane of colour. Nine photographed designs, twenty gloss shades.",
    notes: [
      "Acrylic 2mm back painted on BWP",
      "Zero-edge laser banding for a seamless monolithic look",
      "Shutter height capped at 2400mm"
    ],
    colours: [
      C("Pearl White", "#F5F2EC"), C("Snow", "#FAF8F4"), C("Cream", "#F0E9DC"), C("Sand", "#D9CFBE"),
      C("Beige", "#D2C4AE"), C("Stone", "#B4AC9E"), C("Mocha", "#8A7967"), C("Cappuccino", "#A08A76"),
      C("Cocoa", "#6E5B4A"), C("Espresso", "#493E33"), C("Onyx", "#191714"), C("Graphite", "#2E2C29"),
      C("Wine", "#6E3232"), C("Olive", "#6E6A4F"), C("Sage", "#9AA08C"), C("Petrol", "#3E5451"),
      C("Navy", "#26303B"), C("Terracotta", "#B06B4C"), C("Mustard", "#C49A4C"), C("Blush", "#D8C2B4")
    ],
    designs: [
      D("Design 1", "slab", null, null, { photo: "/images/acrylic/photo-1.jpg", def: 2 }),
      D("Design 2", "slab", null, null, { photo: "/images/acrylic/photo-2.jpg", def: 14 }),
      D("Design 3", "slab", null, null, { photo: "/images/acrylic/photo-3.jpg", def: 7 }),
      D("Design 4", "slab", null, null, { photo: "/images/acrylic/photo-4.jpg", def: 3 }),
      D("Design 5", "slab", null, null, { photo: "/images/acrylic/photo-5.jpg", def: 5 }),
      D("Design 6", "slab", null, null, { photo: "/images/acrylic/photo-6.jpg", def: 5 }),
      D("Design 7", "slab", null, null, { photo: "/images/acrylic/photo-7.jpg", def: 11 }),
      D("Design 8", "slab", null, null, { photo: "/images/acrylic/photo-8.jpg", def: 16 }),
      D("Design 9", "jpull", null, null, { photo: "/images/acrylic/photo-9.jpg", def: 19, tag: "G-Pocket Acrylic" })
    ]
  },
  {
    id: "glass", num: "07", title: "Toughened Glass", accent: "profile-framed colour.",
    texture: "glass",
    blurb: "Toughened glass shutters set in slim anodised aluminium profiles — back-painted colour panels with mirror-deep reflections, edge-sealed on all four sides. Five photographed designs.",
    notes: [
      "Toughened glass set in slim anodised aluminium profile",
      "Back-painted colour panels — edge-sealed, moisture-proof",
      "Profile doors capped at 2400mm with soft-close hinges"
    ],
    colours: [
      C("Clear", "#E8ECEA"), C("Frosted", "#DCE1DE"), C("Extra Clear", "#F0F4F2"), C("Grey Tint", "#55524C"),
      C("Bronze Tint", "#5A4A3C"), C("Smoke", "#3A3A38"), C("Black Lacquer", "#14120F"), C("Champagne", "#C9B08A"),
      C("Green Tint", "#4E5B52"), C("Blue Grey", "#5C6B73"), C("Mirror", "#B9BEC0"), C("Bronze Mirror", "#8A715A"),
      C("Grey Mirror", "#7A7F82"), C("Satin", "#D6D9D6"), C("Tea", "#A08A6A"), C("Dark Tea", "#6E5B45"),
      C("Ocean", "#3F5459"), C("Amber", "#A8763E"), C("Graphite", "#33312E"), C("Milk", "#F2F0EA")
    ],
    designs: [
      D("Design 1", "slab", null, null, { photo: "/images/glass/photo-1.jpg", def: 16 }),
      D("Design 2", "slab", null, null, { photo: "/images/glass/photo-2.jpg", def: 19 }),
      D("Design 3", "slab", null, null, { photo: "/images/glass/photo-3.jpg", def: 11 }),
      D("Design 4", "slab", null, null, { photo: "/images/glass/photo-4.jpg", def: 3 }),
      D("Design 5", "slab", null, null, { photo: "/images/glass/photo-5.jpg", def: 7 })
    ]
  },
  {
    id: "wardrobe", num: "08", title: "Wardrobe Shutters", accent: "made to measure.",
    texture: "smooth",
    tall: true,
    blurb: "Full-height wardrobe shutters in Routed PU, fabric laminate and rattan compositions — built on HDHMR cores and made to measure from 8ft to 10ft heights.",
    notes: [
      "Made-to-measure heights from 8ft to 10ft"
    ],
    colours: [
      C("Porcelain", "#F5F2EA"), C("Ivory Mist", "#EFE9DD"), C("Bone", "#E3DAC8"), C("Sand", "#D9CFBE"),
      C("Silk Grey", "#C7C2B8"), C("Greige", "#B3A898"), C("Stone", "#A69C8E"), C("Taupe", "#8C7D6D"),
      C("Mocha", "#77614C"), C("Espresso", "#493E33"), C("Bronze", "#6B5844"), C("Charcoal", "#2A2723"),
      C("Ink Black", "#141210"), C("Sage", "#9AA08C"), C("Olive", "#6E6A4F"), C("Terracotta", "#B06B4C"),
      C("Clay", "#96604A"), C("Petrol", "#3E5451"), C("Midnight", "#232E3A"), C("Slate Blue", "#5A6672")
    ],
    designs: [
      D("Design 1", "fluted", null, null, { photo: "/images/wardrobe/photo-1.jpg", def: 5, sub: "Routed PU · HDHMR · 8ft – 10ft height" }),
      D("Design 2", "arch", null, null, { photo: "/images/wardrobe/photo-2.jpg", def: 17, sub: "PU · Fabric Laminate · 8ft height" }),
      D("Design 3", "shaker", null, null, { photo: "/images/wardrobe/photo-3.jpg", def: 0, sub: "PU + Rattan · 8ft – 10ft height" }),
      D("Design 4", "fluted", null, null, { photo: "/images/wardrobe/photo-4.jpg", def: 2, sub: "Routed PU · 8ft – 10ft height" }),
      D("Design 5", "arch", null, null, { photo: "/images/wardrobe/photo-5.jpg", def: 4, sub: "Routed PU · 8ft – 10ft height" }),
      D("Design 6", "shaker", null, null, { photo: "/images/wardrobe/photo-6.jpg", def: 2, sub: "Routed PU · 8ft – 10ft height" }),
      D("Design 7", "raised", null, null, { photo: "/images/wardrobe/photo-7.jpg", def: 9, sub: "Solid Wood with Cornice · 8ft – 10ft height" }),
      D("Design 8", "fluted", null, null, { photo: "/images/wardrobe/photo-8.jpg", def: 13, sub: "Membrane in Design · 8ft – 10ft height" }),
      D("Design 9", "arch", null, null, { photo: "/images/wardrobe/photo-9.jpg", def: 19, sub: "PU Rattan · 8ft – 10ft height" }),
      D("Design 10", "arch", null, null, { photo: "/images/wardrobe/photo-10.jpg", def: 0, sub: "Routed PU · 8ft – 10ft height" })
    ]
  }
];
